





import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';

@Component
export default class GridItem extends Vue {
@Prop({default:null}) link:string;
@Prop({default:null}) openlink:string;
@Prop({default:false}) func : boolean;
@Prop({default:false}) right:boolean;


public onClick() {
  if (this.link){
    this.$router.push(this.link);     
  } else if (this.openlink){
    let routeData = this.$router.resolve(this.openlink) ;
    window.open(routeData.href, '_blank');    
  } else if (this.func){
    this.$emit('click');
  }
}
}
